const ImmobileJourneySection = () => {
  return (
    <section id="voyage-immobile" className="py-24 sm:py-36 px-6 bg-[#7e7472]">
      <div className="max-w-2xl mx-auto text-center text-[#F3E5CF]">
        
        {/* Title on two lines */}
        <div className="space-y-2 mb-6">
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl">
            COCON
          </h2>
          <p className="font-serif text-xl sm:text-2xl md:text-3xl italic">
            Le voyage immobile
          </p>
        </div>
        
        {/* Micro-phrase */}
        <p className="text-xs sm:text-sm tracking-[0.2em] uppercase text-[#F9F0E0] mb-16">
          Un déplacement intérieur.
        </p>
        
        {/* Body — sculptural */}
        <div className="space-y-10 text-base sm:text-lg leading-[2.2] italic">
          
          <p style={{ textWrap: 'balance' }}>
            Le voyage le plus long
            <br />ne traverse pas le monde.
          </p>
          
          <p style={{ textWrap: 'balance' }}>
            Il traverse l'être.
          </p>
          
          <p className="text-lg sm:text-xl text-[#C5A059]">
            Quarante centimètres.
          </p>
          
          <p className="text-lg sm:text-xl" style={{ textWrap: 'balance' }}>
            De la tête
            <br />au cœur.
          </p>
          
          <div className="w-8 h-[1px] bg-[#C5A059] mx-auto" />
          
          <p className="text-[#F3E5CF]/60" style={{ textWrap: 'balance' }}>
            Et parfois
            <br />il faut une vie pour le parcourir.
          </p>
          
        </div>
      </div>
    </section>
  );
};

export default ImmobileJourneySection;
